/**
 * engo-scripts-fixed.js
 * --------------------
 * This file replaces a corrupted `assets/engo-scripts.js` that currently starts with ":" which causes:
 *   Uncaught SyntaxError: Unexpected token ':'
 *
 * Strategy:
 * - Keep the working parts of the original script (menu/cart/search/etc).
 * - Re-wrap the orphaned "home slider + section initializers" chunk in a proper ready() block.
 * - Guard calls to functions that may be defined elsewhere (so missing ones won't crash the whole file).
 *
 * IMPORTANT:
 * - This is meant to be loaded INSTEAD OF the broken `engo-scripts.js`.
 */

(function () {
  'use strict';

  // Helper: safely call a global function by name (if it exists).
  function safeCall(name) {
    try {
      var fn = window[name];
      if (typeof fn === 'function') fn();
    } catch (e) {
      // swallow: we never want one section initializer to kill mobile menu/cart
    }
  }

  // Helper: safely call a local function (if it exists)
  function safeCallLocal(fn) {
    try {
      if (typeof fn === 'function') fn();
    } catch (e) {}
  }

  // ------------------------------------------------------------
  // PART 1 — Rebuilt wrapper for the orphaned slider/init chunk
  // (Your broken file starts mid-array with ":"; we intentionally omit that fragment.)
  // ------------------------------------------------------------
  if (window.jQuery) {
    window.jQuery(function ($) {
      // Home sliders (copied from your current `assets/engo-scripts.js`, starting at function slidehome1)
      function slidehome1() {
        $('.slick-side-h1').not('.slick-initialized').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          dots: true,
          arrows: false,
          fade: true,
          adaptiveHeight: true,
          prevArrow:
            '<button type="button" class="prev-slide"><i class="fa fa-long-arrow-left"></i> </button>',
          nextArrow:
            '<button type="button" class="next-slide"><i class="fa fa-long-arrow-right"></i></button>',
          responsive: [
            { breakpoint: 1200, settings: { infinite: true, dots: true, arrows: false } },
            { breakpoint: 1024, settings: { dots: true, arrows: false } },
            { breakpoint: 600, settings: { dots: true, arrows: false } }
          ]
        });
      }

      function slidehome2() {
        $('.slick-side-h2').not('.slick-initialized').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 3500,
          dots: false,
          arrows: true,
          prevArrow:
            '<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i> </button>',
          nextArrow:
            '<button type="button" class="next-slide"> <i class="fa fa-angle-right"></i></button>',
          fade: true,
          responsive: [
            { breakpoint: 1200, settings: { infinite: true, dots: false, arrows: true } },
            { breakpoint: 1024, settings: { dots: false, arrows: true } },
            {
              breakpoint: 900,
              settings: { dots: true, arrows: false, autoplay: true, autoplaySpeed: 3500 }
            }
          ]
        });
      }

      function slidehome4() {
        $('.js-slide-item4').not('.slick-initialized').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 3500,
          dots: true,
          arrows: true,
          prevArrow:
            '<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i></button>',
          nextArrow:
            '<button type="button" class="next-slide"><i class="fa fa-angle-right"></i></button>',
          fade: true,
          responsive: [
            { breakpoint: 1200, settings: { infinite: true, dots: true, arrows: true } },
            { breakpoint: 1024, settings: { dots: true, arrows: false } },
            { breakpoint: 600, settings: { dots: true, arrows: false, autoplay: true } }
          ]
        });
      }

      function slidehome5() {
        $('.slick-side-h5').not('.slick-initialized').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 3500,
          infinite: true,
          dots: false,
          arrows: true,
          prevArrow:
            '<button type="button" class="prev-slide"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
          nextArrow:
            '<button type="button" class="next-slide"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
          fade: false,
          responsive: [
            {
              breakpoint: 1200,
              settings: { infinite: true, dots: false, arrows: true, slidesToShow: 3, slidesToScroll: 1 }
            },
            {
              breakpoint: 1024,
              settings: { dots: false, arrows: true, slidesToShow: 3, slidesToScroll: 1 }
            },
            {
              breakpoint: 768,
              settings: { dots: false, arrows: true, slidesToShow: 2, slidesToScroll: 1 }
            },
            {
              breakpoint: 600,
              settings: { dots: false, arrows: true, autoplay: true, slidesToShow: 1, slidesToScroll: 1 }
            }
          ]
        });
      }

      // Run the sliders we *do* have
      safeCallLocal(slidehome1);
      safeCallLocal(slidehome2);
      safeCallLocal(slidehome4);
      safeCallLocal(slidehome5);

      // Run other original initializers only if they exist globally
      [
        'productV5',
        'productV6',
        'testimonialV1',
        'testimonialV2',
        'servicePage',
        'servicev1',
        'servicev2',
        'brandv1',
        'Collectionv1',
        'Collectionv2',
        'Collectionv3',
        'Blogv1',
        'Blogv2',
        'js_menu_horiontal',
        'product_v1',
        'product_best_seller',
        'jsbannerv1',
        'js_product_flashsale',
        'checkclickcol',
        'jsProdDetails_gallery',
        'jstoolbarScroll',
        'js_draw_filter',
        'productnewh5',
        'js_prod_menu',
        'jschangethumbnail',
        'jsProdDetails',
        'listcollection',
        'jsProdRelate',
        'slideProductDetail',
        'sizeGuide',
        'deliveryReturn',
        'askQuestion',
        'slideProductDetailBottom',
        'sortLayout',
        'changeProdListGrid',
        'FilterPushLeft',
        'jsCollection',
        'heighthdSticky',
        'jsDScollectionV1',
        'jsrelatepost',
        'jscolbreacrumb',
        'slideProductDetail2',
        'jsslidelookbook',
        'jschangeborder'
      ].forEach(safeCall);
    });
  }

  // ------------------------------------------------------------
  // PART 2 — Tooltip guard (prevents runtime crashes on Bootstrap/tooltip mismatch)
  // ------------------------------------------------------------
  if (window.jQuery) {
    window.jQuery(function ($) {
      if ($.fn && typeof $.fn.tooltip === 'function') {
        $('[data-toggle="tooltip"]').tooltip();
      }
    });
  }

  // ------------------------------------------------------------
  // PART 3 — Core UI bindings (menu, cart, account, search, etc.)
  // Copied from your current `assets/engo-scripts.js` and kept defensive.
  // ------------------------------------------------------------
  if (window.jQuery) {
    window.jQuery(function ($) {
      'use strict';

      // Collection filter drawer (works for both "filter_draw" and "filter_push_left" layouts)
      // Uses existing CSS hooks in engo-customizes.css:
      // - .collection-page-fullwidth .filter-to-left.active { left: 0; }
      // - .overlay-filter.active { position: fixed; ... }
      function collectionFilterDrawer() {
        // Open: filter buttons in collection header/toolbars
        $(document).on('click', '.js-draw-filter-btn, .js_filter', function (e) {
          e.preventDefault();
          $('.filter-to-left').addClass('active');
          $('.overlay-filter').addClass('active');
        });

        // Close: X button and overlay click
        $(document).on('click', '.close_filter, .overlay-filter', function (e) {
          e.preventDefault();
          $('.filter-to-left').removeClass('active');
          $('.overlay-filter').removeClass('active');
        });
      }

      // Collection sorting dropdown:
      // The theme's `snippets/collection-sorting.liquid` currently renders links like:
      //   <a href="best-selling">Best selling</a>
      // Those need JS to set ?sort_by=best-selling instead of navigating to /best-selling.
      function collectionSorting() {
        // Fallback dropdown behavior (if Bootstrap dropdown JS isn't active)
        // Theme markup uses Bootstrap 4 attributes (data-toggle="dropdown").
        $(document).on('click', '.collection-sorting .dropdown-toggle', function (e) {
          e.preventDefault();
          var $dropdown = $(this).closest('.dropdown');
          var $menu = $dropdown.find('.dropdown-menu, .dropdown-content').first();
          $dropdown.toggleClass('show');
          $menu.toggleClass('show');
        });

        // Close dropdown when clicking outside
        $(document).on('click', function (e) {
          if ($(e.target).closest('.collection-sorting .dropdown').length) return;
          $('.collection-sorting .dropdown').removeClass('show');
          $('.collection-sorting .dropdown-menu, .collection-sorting .dropdown-content').removeClass('show');
        });

        $(document).on('click', '.collection-sorting .dropdown-content a, .collection-sorting .dropdown-menu a', function (e) {
          // Links are now real URLs (recommended). If JS runs, just let navigation happen.
          // We only preventDefault for legacy values like "best-selling" without a URL.
          var href = ($(this).attr('href') || '').trim();
          if (!href || href === '#') return;
          if (href.indexOf('http') === 0 || href.indexOf('/') === 0 || href.indexOf('?') >= 0) return;

          // Legacy fallback: convert to ?sort_by=<value>
          e.preventDefault();
          var params = new URLSearchParams(window.location.search);
          params.set('sort_by', href);
          window.location.search = params.toString();
        });
      }

      // Collection tag filters:
      // Theme renders checkboxes + <a href="javascript:void(0)">...</a> in:
      // - snippets/collection.shopby-color.liquid
      // - snippets/collection.shopby-size.liquid
      // - snippets/collection.shopby-price.liquid
      // - snippets/collection-widget-tags.liquid
      //
      // This handler converts checkbox selections to a Shopify tag URL:
      //   /collections/<handle>/<tag1>+<tag2>?sort_by=...
      function collectionTagFilters() {
        function isCollectionListingPage() {
          var p = window.location.pathname || '';
          // Exclude /collections/<handle>/products/<product-handle>
          return p.indexOf('/collections/') === 0 && p.indexOf('/products/') === -1;
        }

        function getCollectionBasePath() {
          var p = window.location.pathname || '';
          // /collections/<handle>[/<tags>]
          var m = p.match(/^\/collections\/([^\/?#]+)/);
          if (!m) return null;
          return '/collections/' + m[1];
        }

        function applyFilters() {
          if (!isCollectionListingPage()) return;
          var base = getCollectionBasePath();
          if (!base) return;

          // Gather selected tags from the sidebar widgets
          var tags = [];
          // Only legacy widgets (they have `.filter-tag` and do NOT have name="filter.*")
          $('.engoc_sw_filter_tag .filter-tag input[type="checkbox"]:checked').each(function () {
            if (this.name && String(this.name).indexOf('filter.') === 0) return;
            var v = String($(this).val() || '').trim();
            if (v) tags.push(v);
          });

          // Build new path
          var newPath = base + (tags.length ? '/' + tags.join('+') : '');

          // Preserve query params (sort_by, view, etc), but reset pagination
          var params = new URLSearchParams(window.location.search);
          params.delete('page');

          var qs = params.toString();
          window.location.href = newPath + (qs ? '?' + qs : '');
        }

        // Clicking the label/link toggles checkbox then applies filters
        $(document).on('click', '.engoc_sw_filter_tag .filter-tag a[href="javascript:void(0)"]', function (e) {
          e.preventDefault();
          var $li = $(this).closest('li');
          var $cb = $li.find('input[type="checkbox"]').first();
          if ($cb.length) {
            $cb.prop('checked', !$cb.prop('checked'));
          }
          // Mirror active class for styling
          $(this).toggleClass('active', $cb.is(':checked'));
          $li.toggleClass('current-cat', $cb.is(':checked'));
          applyFilters();
        });

        // Clicking the checkbox itself also applies
        $(document).on('change', '.engoc_sw_filter_tag .filter-tag input[type="checkbox"]', function () {
          // Ignore Shopify native facets
          if (this.name && String(this.name).indexOf('filter.') === 0) return;
          var $li = $(this).closest('li');
          $li.find('a[href="javascript:void(0)"]').toggleClass('active', $(this).is(':checked'));
          $li.toggleClass('current-cat', $(this).is(':checked'));
          applyFilters();
        });
      }

      // Shopify native facets (Search & Discovery):
      // Submit the facets form on checkbox change for better UX.
      function collectionShopifyFacets() {
        $(document).on('change', 'form.hh-facets input[type="checkbox"]', function () {
          var form = $(this).closest('form')[0];
          if (form) form.submit();
        });
      }

      // Collection grid/list + columns (2/3/4/5/6) switcher
      // Theme markup examples:
      // - <div class="prod_per"><a href="javascript:void(0)" class="size_2">2</a> ...</div>
      // - <div class="prod_grid">...</div> / <div class="prod_list">...</div>
      // - Products have `.js_size_prod` + Bootstrap column classes.
      function collectionViewSwitcher() {
        function storageGet(key) {
          try {
            if (window.localStorage) return window.localStorage.getItem(key);
          } catch (e) {}
          try {
            if (window.jQuery && typeof window.jQuery.cookie === 'function') return window.jQuery.cookie(key);
          } catch (e) {}
          return null;
        }

        function storageSet(key, value) {
          try {
            if (window.localStorage) window.localStorage.setItem(key, value);
          } catch (e) {}
          try {
            if (window.jQuery && typeof window.jQuery.cookie === 'function')
              window.jQuery.cookie(key, value, { expires: 30, path: '/' });
          } catch (e) {}
        }

        function stripColClasses(el) {
          var cls = (el.className || '').split(/\s+/);
          var keep = [];
          for (var i = 0; i < cls.length; i++) {
            var c = cls[i];
            if (!c) continue;
            if (c === 'col-lg-2dot4') continue;
            if (/^col(?:-[a-z]+)?-\d+$/.test(c)) continue;
            keep.push(c);
          }
          el.className = keep.join(' ');
        }

        function colsToClasses(n) {
          // default: keep mobile usable
          switch (String(n)) {
            case '1':
              return ['col-12'];
            case '2':
              return ['col-6', 'col-md-6', 'col-lg-6'];
            case '3':
              return ['col-6', 'col-md-4', 'col-lg-4'];
            case '4':
              return ['col-6', 'col-md-4', 'col-lg-3'];
            case '5':
              return ['col-6', 'col-md-4', 'col-lg-2dot4'];
            case '6':
              return ['col-6', 'col-md-4', 'col-lg-2'];
            default:
              return null;
          }
        }

        function setCols(n, $root) {
          var classes = colsToClasses(n);
          if (!classes) return;

          var $scope = ($root && $root.length ? $root : $(document));
          var $items = $scope.find('.product-grid-view .js_size_prod');
          if (!$items.length) return;

          $items.each(function () {
            stripColClasses(this);
            for (var i = 0; i < classes.length; i++) {
              this.classList.add(classes[i]);
            }
          });
        }

        function setView(mode, $root) {
          var m = mode === 'list' ? 'list' : 'grid';
          var $scope = ($root && $root.length ? $root : $(document));
          var $grid = $scope.find('.product-grid-view');
          var $list = $scope.find('.product-list-view');
          if (!$grid.length && !$list.length) return;

          if (m === 'list') {
            $grid.removeClass('active').hide();
            $list.addClass('active').show();
          } else {
            $list.removeClass('active').hide();
            $grid.addClass('active').show();
          }
        }

        // Bind: column count links
        $(document).on('click', '.prod_per a[class*="size_"]', function (e) {
          e.preventDefault();
          var $a = $(this);
          var m = ($a.attr('class') || '').match(/\bsize_(\d+)\b/);
          if (!m) return;
          var n = parseInt(m[1], 10);
          if (!n) return;

          var $root = $a.closest('section');
          setCols(n, $root);
          storageSet('hh_collection_cols', String(n));

          // active state
          var $wrap = $a.closest('.prod_per');
          $wrap.find('a').removeClass('active');
          $a.addClass('active');
        });

        // Bind: grid/list toggles (some templates use <div>, not <a>)
        $(document).on('click', '.style_layout_prod .prod_grid, .style_layout_prod .prod_list', function (e) {
          e.preventDefault();
          var $btn = $(this);
          var isList = $btn.hasClass('prod_list');
          var $root = $btn.closest('section');
          setView(isList ? 'list' : 'grid', $root);
          storageSet('hh_collection_view', isList ? 'list' : 'grid');

          $btn.closest('.style_layout_prod').find('.prod_grid, .prod_list').removeClass('active');
          $btn.addClass('active');
        });

        // Apply saved preferences on load (best-effort)
        var savedCols = storageGet('hh_collection_cols');
        if (savedCols) setCols(parseInt(savedCols, 10), $(document));

        var savedView = storageGet('hh_collection_view');
        if (savedView) setView(savedView, $(document));
      }

      // Product image carousel (Slick)
      // In this theme, multiple product templates output stacked images inside:
      // - .js_prod_detail_gallery  (snippets/product-slide-gallery.liquid)
      // - .js_prod_detail          (snippets/product-details-large-image.liquid)
      // - .prod_sticky .img_thumb  (snippets/product-details-sticky.liquid, etc.)
      //
      // If the slick init is missing, images appear one-after-another vertically.
      function productImageCarousel() {
        if (!$.fn || typeof $.fn.slick !== 'function') return;

        function init($el, slideSelector) {
          if (!$el || !$el.length) return;
          if ($el.hasClass('slick-initialized')) return;

          // Only carousel when there are multiple slides
          var slideSel = slideSelector || '.engoj-nav-item';
          var slideCount = $el.find(slideSel).length;
          if (slideCount < 2) return;

          $el.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            infinite: false,
            adaptiveHeight: true,
            prevArrow:
              '<button type="button" class="prev-slide" aria-label="Previous"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
            nextArrow:
              '<button type="button" class="next-slide" aria-label="Next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>'
          });
        }

        // Initialize on common containers
        init($('.js_prod_detail_gallery'), '.engoj-nav-item'); // pd_slide_gallery
        init($('.js_prod_detail'), '.engoj-nav-item'); // pd_large_img
        init($('.prod_sticky .img_thumb'), '.engoj-nav-item'); // sticky templates
        init($('.prod_largeimg .img_thumb'), '.engoj-nav-item'); // large img templates

        // Extended product layout uses .js_prod_main / .js_prod_main2 with direct child <div> slides
        // (snippets/product-extended.liquid)
        init($('.js_prod_main'), '> div');
        init($('.js_prod_main2'), '> div');
      }

      function promo() {
        $('.close_promo_topbar').on('click', function () {
          $('.promo_topbar').addClass('active');
        });
      }

      function search() {
        $('.js-search-destop').on('click', function () {
          $('.js-box-search').addClass('active');
          $('.bg_search_box').addClass('active');
          $('body').addClass('activedestop');
        });
        $('.js-drawer-close').on('click', function () {
          $('.js-box-search').removeClass('active');
          $('.bg_search_box').removeClass('active');
          $('body').removeClass('activedestop');
        });
        $('.bg_search_box').on('click', function () {
          $('.js-box-search').removeClass('active');
          $('.bg_search_box').removeClass('active');
          $('body').removeClass('activedestop');
        });
      }

      function minicart() {
        // Use delegated binding so it also works after AJAX updates
        $(document).on('click', '.js-call-minicart', function (e) {
          e.preventDefault();
          $('.js-minicart').addClass('active');
          $('.bg-minicart').addClass('active');
        });
        $(document).on('click', '.close-mini-cart, .bg-minicart', function (e) {
          e.preventDefault();
          $('.js-minicart').removeClass('active');
          $('.bg-minicart').removeClass('active');
        });
      }

      function miniaccount() {
        $(document).on('click', '.js-call-account', function (e) {
          e.preventDefault();
          $(this).toggleClass('active');
          $('.box_contentmenu').toggleClass('active');
          $('.box_contentmenu_background').toggleClass('active');
          $('body').addClass('activemenu_mobile');

          $('.tab_navar').removeClass('active');
          $('.tab_navar_right').addClass('active');

          $('.tab-pane:nth-child(1)').removeClass('show active');
          $('.tab-pane:nth-child(2)').addClass('show active');
          $('.form_register').hide();
        });
      }

      function clickshow() {
        $(document).on('click', '.item-toggle-tab', function () {
          $(this).toggleClass('active');
        });
      }

      function menumobile() {
        $(document).on('click', '.menuleft', function (e) {
          e.preventDefault();
          $(this).toggleClass('active');
          $('.box_contentmenu').toggleClass('active');
          $('.box_contentmenu_background').toggleClass('active');
          $('body').addClass('activemenu_mobile');
        });
        $(document).on('click', '.box_contentmenu_background, .js-eveland-close', function (e) {
          e.preventDefault();
          $('.box_contentmenu').removeClass('active');
          $('.menuleft').removeClass('active');
          $('.box_contentmenu_background').removeClass('active');
          $('body').removeClass('activemenu_mobile');
        });
      }

      function menutoolbar() {
        $(document).on('click', '.btn_bar', function (e) {
          e.preventDefault();
          $(this).toggleClass('active');
          $('.box_contentmenu').toggleClass('active');
          $('.box_contentmenu_background').toggleClass('active');
        });
      }

      function popup() {
        $(document).on('click', '.jsclosepoup', function () {
          $('.jsengo_popup').addClass('d-none');
        });
      }

      function popup2() {
        $(document).on('click', '.jsclose_cookie', function () {
          $('.jscookie_popup').addClass('d-none');
        });
      }

      function cookiepopup() {
        if (typeof window.jQuery.cookie !== 'function') return;
        if (!jQuery.cookie('brilliant_pop_newletter') || jQuery.cookie('brilliant_pop_newletter') == null) {
          $(window).on('load', function () {
            setTimeout(function () {
              $('.jsengo_popup').show();
            }, 300 * 1000);
            jQuery('.jsclosepoup').on('click', function (e) {
              e.preventDefault();
              jQuery('.jsengo_popup').hide();
              jQuery.cookie('brilliant_pop_newletter', '1', { expires: 1, path: '/', domain: '' });
            });
          });
        } else {
          $('.jsengo_popup').remove();
        }
      }

      function cookiepopup2() {
        if (typeof window.jQuery.cookie !== 'function') return;
        if (!jQuery.cookie('cookie_popup') || jQuery.cookie('cookie_popup') == null) {
          $(window).on('load', function () {
            setTimeout(function () {
              $('.jscookie_popup').show();
            }, 300 * 1000);
            jQuery('.jsclose_cookie').on('click', function (e) {
              e.preventDefault();
              jQuery('.jscookie_popup').hide();
              jQuery.cookie('cookie_popup', '1', { expires: 1, path: '/', domain: '' });
            });
          });
        } else {
          $('.jscookie_popup').remove();
        }
      }

      // Run core bindings
      try {
        cookiepopup();
      } catch (e) {}
      try {
        cookiepopup2();
      } catch (e) {}
      collectionFilterDrawer();
      collectionSorting();
      collectionTagFilters();
      collectionShopifyFacets();
      collectionViewSwitcher();
      productImageCarousel();
      popup();
      popup2();
      menumobile();
      menutoolbar();
      minicart();
      miniaccount();
      clickshow();
      search();
      promo();
    });
  }

  // ------------------------------------------------------------
  // PART 4 — Other small behaviors from original file
  // ------------------------------------------------------------
  if (window.jQuery) {
    window.jQuery(function ($) {
      $(document).on('change', '.engoj-agree', function () {
        var input_is_checked = $('.engoj-agree'),
          btn_dynamic_checkout = $('.more_info').find('.js-button-checkout');
        input_is_checked.is(':checked')
          ? btn_dynamic_checkout.removeClass('btn-disabled')
          : btn_dynamic_checkout.addClass('btn-disabled');
      });
    });
  }

  // ------------------------------------------------------------
  // PART 5 — Zoom plugin + init (copied from your current `assets/engo-scripts.js`)
  // ------------------------------------------------------------
  if (window.jQuery) {
    window.jQuery(document).ready(function ($) {
      (function ($) {
        var defaults = {
          url: false,
          callback: false,
          target: false,
          duration: 120,
          on: 'mouseover', // other options: grab, click, toggle
          touch: true, // enables a touch fallback
          onZoomIn: false,
          onZoomOut: false,
          magnify: 0.9
        };

        $.zoom = function (target, source, img, magnify) {
          var targetHeight,
            targetWidth,
            sourceHeight,
            sourceWidth,
            xRatio,
            yRatio,
            offset,
            $target = $(target),
            position = $target.css('position'),
            $source = $(source);

          target.style.position = /(absolute|fixed)/.test(position) ? position : 'relative';
          target.style.overflow = 'hidden';
          img.style.width = img.style.height = '';

          $(img)
            .addClass('zoomImg engoj_img_main')
            .css({
              position: 'absolute',
              top: 0,
              left: 0,
              opacity: 0,
              width: img.width * magnify,
              height: img.height * magnify,
              border: 'none',
              maxWidth: 'none',
              maxHeight: 'none'
            })
            .appendTo(target);

          return {
            init: function () {
              targetWidth = $target.outerWidth();
              targetHeight = $target.outerHeight();

              if (source === target) {
                sourceWidth = targetWidth;
                sourceHeight = targetHeight;
              } else {
                sourceWidth = $source.outerWidth();
                sourceHeight = $source.outerHeight();
              }

              xRatio = (img.width - targetWidth) / sourceWidth;
              yRatio = (img.height - targetHeight) / sourceHeight;

              offset = $source.offset();
            },
            move: function (e) {
              var left = e.pageX - offset.left,
                top = e.pageY - offset.top;

              top = Math.max(Math.min(top, sourceHeight), 0);
              left = Math.max(Math.min(left, sourceWidth), 0);

              img.style.left = left * -xRatio + 'px';
              img.style.top = top * -yRatio + 'px';
            }
          };
        };

        $.fn.zoom = function (options) {
          return this.each(function () {
            var settings = $.extend({}, defaults, options || {}),
              target = (settings.target && $(settings.target)[0]) || this,
              source = this,
              $source = $(source),
              img = document.createElement('img'),
              $img = $(img),
              mousemove = 'mousemove.zoom',
              clicked = false,
              touched = false;

            if (!settings.url) {
              var srcElement = source.querySelector('img');
              if (srcElement) {
                settings.url =
                  srcElement.getAttribute('data-src') || srcElement.currentSrc || srcElement.src;
              }
              if (!settings.url) return;
            }

            $source.one(
              'zoom.destroy',
              function (position, overflow) {
                $source.off('.zoom');
                target.style.position = position;
                target.style.overflow = overflow;
                img.onload = null;
                $img.remove();
              }.bind(this, target.style.position, target.style.overflow)
            );

            img.onload = function () {
              var zoom = $.zoom(target, source, img, settings.magnify);

              function start(e) {
                zoom.init();
                zoom.move(e);
                $img
                  .stop()
                  .fadeTo(
                    $.support.opacity ? settings.duration : 0,
                    1,
                    $.isFunction(settings.onZoomIn) ? settings.onZoomIn.call(img) : false
                  );
              }

              function stop() {
                $img
                  .stop()
                  .fadeTo(
                    settings.duration,
                    0,
                    $.isFunction(settings.onZoomOut) ? settings.onZoomOut.call(img) : false
                  );
              }

              if (settings.on === 'grab') {
                $source.on('mousedown.zoom', function (e) {
                  if (e.which === 1) {
                    $(document).one('mouseup.zoom', function () {
                      stop();
                      $(document).off(mousemove, zoom.move);
                    });
                    start(e);
                    $(document).on(mousemove, zoom.move);
                    e.preventDefault();
                  }
                });
              } else if (settings.on === 'click') {
                $source.on('click.zoom', function (e) {
                  if (clicked) return;
                  clicked = true;
                  start(e);
                  $(document).on(mousemove, zoom.move);
                  $(document).one('click.zoom', function () {
                    stop();
                    clicked = false;
                    $(document).off(mousemove, zoom.move);
                  });
                  return false;
                });
              } else if (settings.on === 'toggle') {
                $source.on('click.zoom', function (e) {
                  if (clicked) stop();
                  else start(e);
                  clicked = !clicked;
                });
              } else if (settings.on === 'mouseover') {
                zoom.init();
                $source.on('mouseenter.zoom', start).on('mouseleave.zoom', stop).on(mousemove, zoom.move);
              }

              if (settings.touch) {
                $source
                  .on('touchstart.zoom', function (e) {
                    e.preventDefault();
                    if (touched) {
                      touched = false;
                      stop();
                    } else {
                      touched = true;
                      start(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]);
                    }
                  })
                  .on('touchmove.zoom', function (e) {
                    e.preventDefault();
                    zoom.move(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]);
                  })
                  .on('touchend.zoom', function (e) {
                    e.preventDefault();
                    if (touched) {
                      touched = false;
                      stop();
                    }
                  });
              }

              if ($.isFunction(settings.callback)) settings.callback.call(img);
            };

            img.setAttribute('role', 'presentation');
            img.alt = '';
            img.src = settings.url;
          });
        };

        $.fn.zoom.defaults = defaults;
      })(window.jQuery);

      $('.js-zoom-img').zoom();
    });
  }
})();

// =========================================================
// Price Filter Spinner Buttons
// =========================================================
(function() {
  $(document).on('click', '.hh-price__spin', function(e) {
    e.preventDefault();
    var $btn = $(this);
    var targetId = $btn.data('target');
    var dir = $btn.data('dir');
    var $input = $('#' + targetId);
    
    if (!$input.length) return;
    
    var currentVal = parseInt($input.val(), 10) || 0;
    var step = 10; // Increment by 10
    
    if (dir === 'up') {
      $input.val(currentVal + step);
    } else if (dir === 'down') {
      var newVal = currentVal - step;
      $input.val(newVal < 0 ? 0 : newVal);
    }
    
    // Trigger change event for any listeners
    $input.trigger('change');
  });
})();


